import { Button, ButtonProps } from './Button';

type Props = ButtonProps;
export function TertiaryButton(props: Props) {
    return <Button {...props} variant="tertiary" />;
}
